(function() { window.GUID_6947e5b6_2ece_44c1_8d77_abee4dba9764 = { getGuid: function() { return "6947e5b6-2ece-44c1-8d77-abee4dba9764"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-eventscontainoper",
                        callback: function (control, e) {
                            control.$Container.offon("click.event-box", ".event-box__header", function (e) {
                                const $target = $(e.target), $eventBox = $target.closest(".event-box"), url = $eventBox.data("url");
                                if (url != null) {
                                    CS.Nav.Go(url);
                                }
                            });
                        }
                    });
                    //CS.Controls.Accordion.Events.ContentLoaded({
                    //    selector: "body",
                    //    childSelector: ".accordion-eventscontainoper",
                    //    callback: function (control, e) {
                    //        GoogleAds.BindAds(true);
                    //    }
                    //});
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-box.js.map
